module.exports = __webpack_public_path__ + "static/media/banner_sports.0da533cd.png";